import {api, ApiResponse} from "./api";

export interface PaymentIntent {
	clientSecret: string;
}

/** Get a panier by id */
export const getPaymentIntent = async (): Promise<any> => {
	try {
		const response = await api.post<ApiResponse<any>>(`/paniers/paymentIntent`);
		return response.data.data;
	} catch (error) {
		console.error('Erreur lors de l\'initialisation du paiement:', error);
		throw error;
	}
}